<template>
  <section class="w-90 ma-auto">
    <v-row no-gutters class="gray">
      <v-col cols="12" lg="6" xl="6" md="12" sm="12" >
        <v-img height="500" src="@/assets/images/product-images/karbonat-sodium.jpg"></v-img>
      </v-col>
      <v-col  class="d-flex flex-column justify-center align-center" cols="12" lg="6" xl="6" md="12" sm="12" >
        <div class="text-center w-80">
          <h1 class="my-4">صنعت ساختمان</h1>
          <p>AGC Glass Europe به دلیل تخصص خود در ترکیب و روکش شیشه ، تلاش می کند تا بهترین پاسخ معماری به الزامات انتقال نور ، عایق حرارتی یا صوتی ، کنترل خورشیدی ، امنیت ، زیبایی شناسی و تولید انرژی را ارائه دهد. به علاوه راه حل های جدید ارائه شده توسط شیشه در زمینه ارتباطات و ارتباطات.</p>
        </div>
      </v-col>
    </v-row>
    <v-row  no-gutters class="accent my-4">
      <v-col  class="d-flex flex-column justify-center align-center" cols="12" lg="6" xl="6" md="12" sm="12" >
        <div class="text-center w-80">
          <h1 class="my-4">صنعت ساختمان</h1>
          <p>AGC Glass Europe به دلیل تخصص خود در ترکیب و روکش شیشه ، تلاش می کند تا بهترین پاسخ معماری به الزامات انتقال نور ، عایق حرارتی یا صوتی ، کنترل خورشیدی ، امنیت ، زیبایی شناسی و تولید انرژی را ارائه دهد. به علاوه راه حل های جدید ارائه شده توسط شیشه در زمینه ارتباطات و ارتباطات.</p>
        </div>
      </v-col>
      <v-col cols="12" lg="6" xl="6" md="12" sm="12" >
        <v-img height="500" src="@/assets/images/product-images/architucture-glass.jpg"></v-img>
      </v-col>
    </v-row>
    <v-row  no-gutters class="success my-4">
      <v-col cols="12" lg="6" xl="6" md="12" sm="12" >
        <v-img height="500" src="@/assets/images/product-images/float-glass.jpg"></v-img>
      </v-col>
      <v-col  class="d-flex flex-column justify-center align-center" cols="12" lg="6" xl="6" md="12" sm="12" >
        <div class="text-center w-80">
          <h1 class="my-4">صنعت ساختمان</h1>
          <p>AGC Glass Europe به دلیل تخصص خود در ترکیب و روکش شیشه ، تلاش می کند تا بهترین پاسخ معماری به الزامات انتقال نور ، عایق حرارتی یا صوتی ، کنترل خورشیدی ، امنیت ، زیبایی شناسی و تولید انرژی را ارائه دهد. به علاوه راه حل های جدید ارائه شده توسط شیشه در زمینه ارتباطات و ارتباطات.</p>
        </div>
      </v-col>
    </v-row>
    <div
        class="load-more"
    >
      {{$t('more')}}
    </div>
  </section>
</template>
<script>
export default {
  name: 'projects'
}
</script>
<style scoped>
.one h1 {
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 5px;
}

.load-more {
  margin:  auto;
  width:20vw;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #25458c;
  background: #FCC300;
}
.load-more:hover{
  background: #7BAD32;
  color: white;

  transition: all 0.5s;
}
</style>